import { classnames } from '@bem-react/classnames'
import type { ComboboxPropRenderItem } from '@consta/uikit/Combobox'
import { cnMixSpace } from '@consta/uikit/MixSpace'
import { Text } from '@consta/uikit/Text'

import type { Item } from '../types'
import css from './DraftComboboxItem.css'

const className = classnames(cnMixSpace({ pH: 'xs', pV: '2xs' }), css.draftComboboxItem)

type RenderItemProps<T extends object> = Parameters<ComboboxPropRenderItem<T>>['0']

/**
 * Компонент для рендера драфтого элемента в развернутом списке Select/Combobox
 *
 * Объекты, помещаемые в Select/Combobox должны расширять следующий тип:
 *
 * ```ts
 * type Item = {
 *   state: 'Draft' | 'Public'
 *   name?: string
 * }
 * ```
 */
export function DraftComboboxItem<T extends Item>({
  item: { state, name },
  active,
  onClick,
  onMouseEnter,
}: RenderItemProps<T>) {
  const isDraft = state === 'Draft'

  return (
    <Text
      className={className}
      as="div"
      size="xs"
      lineHeight="xs"
      fontStyle={isDraft ? 'italic' : undefined}
      view={isDraft ? 'ghost' : 'primary'}
      role="option"
      aria-selected={active}
      onClick={onClick}
      onMouseEnter={onMouseEnter}>
      {name}
    </Text>
  )
}
